module.exports = __webpack_public_path__ + "static/media/image2.fb53e1e8.jpg";